module.exports = __webpack_public_path__ + "static/1-3-719fc8c55b6587f2e834f5b1c8db91c5.jpg";